import './App.scss';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider, useAuth } from './hooks/useAuth';
import AppRouter from './routers/app-router';
import { useEffect, useState } from 'react';
import NetworkBanner from './components/network-banner/network-banner';

const App = () => {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    window.addEventListener('online', setOnlineStatus)
    window.addEventListener('offline', setOfflineStatus)
  }, []);

  const setOnlineStatus = () => {
    setOffline(false);
  };

  const setOfflineStatus = () => {
    setOffline(true);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
            <AppRouter/>
        </AuthProvider>
      </BrowserRouter>
      <NetworkBanner show = {offline}/>
    </div>
  );
}

export default App;
